/* ============================================================
   Shopify — Add to Cart & Go to Checkout
   ============================================================ */
function addToCartAndRedirect(e) {
  if (e) e.preventDefault();
  
  const variantId = window.SHOPIFY_VARIANT_ID;
  
  if (!variantId || variantId === "" || variantId === "null" || variantId === "undefined") {
    // Fallback: Exact Product Page URL
    window.location.href = '/products/5000-gym-workout-animated-reels-bundle';
    return;
  }

  // Direct Checkout via Shopify Cart Permalink
  window.location.href = `/cart/${variantId}:1`;
}

/* ============================================================
   Countdown Timer
   ============================================================ */
(function initCountdown() {
  const STORAGE_KEY = 'gymReelsDeadline';
  let deadline = localStorage.getItem(STORAGE_KEY);
  if (!deadline) {
    deadline = Date.now() + 24 * 60 * 60 * 1000; // 24 hours from first visit
    localStorage.setItem(STORAGE_KEY, deadline);
  }
  deadline = parseInt(deadline, 10);

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const diff = Math.max(0, deadline - Date.now());
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const el = document.getElementById('countdown');
    if (el) el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
    if (diff > 0) setTimeout(tick, 1000);
    else {
      if (el) el.textContent = '00:00:00';
    }
  }
  tick();
})();

/* ============================================================
   Sticky Bar — show after hero passes viewport
   ============================================================ */
(function initStickyBar() {
  const bar = document.getElementById('sticky-bar');
  const hero = document.getElementById('hero');
  if (!bar || !hero) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        bar.classList.add('visible');
      } else {
        bar.classList.remove('visible');
      }
    },
    { threshold: 0 }
  );
  observer.observe(hero);
})();

/* ============================================================
   FAQ Toggle
   ============================================================ */
function toggleFaq(item) {
  const isOpen = item.classList.contains('open');
  // close all
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

/* ============================================================
   Video Controls — exclusive play + volume toggle + auto pause on scroll
   ============================================================ */

const PLAY_ICON  = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>`;
const PAUSE_ICON = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>`;
const VOL_ON     = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>`;
const VOL_OFF    = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>`;

function resetVideoCard(card) {
  const v   = card.querySelector('.reel-video');
  const btn = card.querySelector('.play-btn');
  if (v) {
    v.pause();
    v.muted = true;
  }
  if (btn) btn.innerHTML = PLAY_ICON;
  card.classList.remove('is-playing');
  const volBtn = card.querySelector('.vol-btn');
  if (volBtn) volBtn.innerHTML = VOL_OFF;
}

function toggleVideo(btn) {
  const card  = btn.closest('.video-card');
  const video = card.querySelector('.reel-video');

  if (video.paused) {
    // Dusri sabhi videos ko pause kardo pehle
    document.querySelectorAll('.video-card').forEach(c => {
      if (c !== card) resetVideoCard(c);
    });
    
    video.muted = false;
    video.play();
    btn.innerHTML = PAUSE_ICON;
    card.classList.add('is-playing');
    const volBtn = card.querySelector('.vol-btn');
    if (volBtn) volBtn.innerHTML = VOL_ON;
  } else {
    video.pause();
    btn.innerHTML = PLAY_ICON;
    card.classList.remove('is-playing');
  }
}

function toggleMute(btn) {
  const card  = btn.closest('.video-card');
  const video = card.querySelector('.reel-video');
  if (video.muted) {
    video.muted = false;
    btn.innerHTML = VOL_ON;
  } else {
    video.muted = true;
    btn.innerHTML = VOL_OFF;
  }
}

/* Scroll karne par video automatically pause ho jayegi */
document.addEventListener("DOMContentLoaded", function() {
  const videoCards = document.querySelectorAll('.video-card');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        resetVideoCard(entry.target);
      }
    });
  }, { threshold: 0.2 });

  videoCards.forEach(card => observer.observe(card));
});

/* ============================================================
   Particle field in hero
   ============================================================ */
(function spawnParticles() {
  const container = document.getElementById('hero-particles');
  if (!container) return;
  const count = 30;
  for (let i = 0; i < count; i++) {
    const p = document.createElement('span');
    p.style.cssText = `
      position: absolute;
      width: ${Math.random() * 3 + 1}px;
      height: ${Math.random() * 3 + 1}px;
      background: rgba(200,241,53,${Math.random() * 0.5 + 0.1});
      border-radius: 50%;
      top: ${Math.random() * 100}%;
      left: ${Math.random() * 100}%;
      animation: particleFloat ${Math.random() * 8 + 6}s ease-in-out ${Math.random() * 5}s infinite alternate;
      pointer-events: none;
    `;
    container.appendChild(p);
  }

  // inject keyframes
  const style = document.createElement('style');
  style.textContent = `
    @keyframes particleFloat {
      0%   { transform: translateY(0) scale(1); opacity: .4; }
      100% { transform: translateY(-${Math.random() * 60 + 30}px) scale(1.5); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
})();

/* ============================================================
   Scroll-reveal for cards
   ============================================================ */
(function initReveal() {
  const targets = document.querySelectorAll(
    '.fy-card, .video-card, .ig-card, .money-card, .bonus-card, .review-card, .faq-item, .ba-card, .order-item, .step'
  );

  const revealStyle = document.createElement('style');
  revealStyle.textContent = `
    .reveal-hidden {
      opacity: 0;
      transform: translateY(28px);
      transition: opacity .55s ease, transform .55s ease;
    }
    .reveal-visible {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  document.head.appendChild(revealStyle);

  targets.forEach(el => el.classList.add('reveal-hidden'));

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.remove('reveal-hidden');
            entry.target.classList.add('reveal-visible');
          }, 60 * (Array.from(targets).indexOf(entry.target) % 6));
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  targets.forEach(el => io.observe(el));
})();

/* ============================================================
   Smooth scroll for internal # links (except checkout button)
   ============================================================ */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    if (this.getAttribute('onclick')) return; // ignore buttons with custom onclick
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});